
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  
  const createho005 = {
    label: "Create Branch Holiday Schedule",
    pageLabel: "Create Branch Holiday Schedule",
    starting: true,
    url: "createho005",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Holiday Type",
            name: "",
            description: "Enter Holiday Type"
          },
          {
            inputType: "select",
            
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "All",
                value: "All"
              },
              {
                label: "Special Holiday",
                value: "SpecialHoliday"
              },
              {
                label: "Day Of The Week",
                value: "WeeklyOff"
              },
              {
                label: "Special Reason For Branch Holiday",
                value: "SpecialReasonForBranchHoliday"
              },
              {
                label: "Alternate Week Off",
                value: "AlternateWeekOff"
              }
             ],
            placeHolder: "Holiday Type",
            name: "HolidayType",
            description: "Enter Holiday Type"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Parent Branch",
            name: "",
            description: "Enter Parent Branch" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Parent Branch",
            name: "ParentBranch",
            description: "Parent Branch"
          }, 
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Day Of The Week",
            name: "",
            description: "Enter Day Of The Week"
          },
          {
            inputType: "select",
            
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Monday",
                value: "Monday"
              },
              {
                label: "Tuesday",
                value: "Tuesday"
              },
              {
                label: "Wednesday",
                value: "Wednesday"
              },
              {
                label: "Thursday",
                value: "Thursday"
              },
              {
                label: "Friday",
                value: "Friday"
              },
              {
                label: "Saturday",
                value: "Saturday"
              },
              {
                label: "Sunday",
                value: "Sunday"
              },
             ],
            placeHolder: "Day Of The Week",
            name: "DayOfTheWeek",
            description: "Enter Day Of The Week"
          },               
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Until",
            name: "",
            description: "Enter Until"
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Until",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            name: "Until",
            description: "Enter Until"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Description",
            name: "",
            description: "Enter Description"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Description",
            name: "Description",
            description: "Enter Description"
          },

    ]
}

export default createho005;